<script>
    import { Bar } from 'vue-chartjs'

    export default {
        extends: Bar,
        props: ['labels', 'datasets', 'xlabel', 'ylabel'],
        computed: {
            'chartdata': function () {
                return {
                    labels: this.labels,
                    datasets: this.datasets
                }
            }
        },
        mounted() {
            this.renderChart(this.chartdata,
                {responsive: true, maintainAspectRatio: false, scales: {
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: this.xlabel
                        }
                    }],
                        yAxes: [{
                            scaleLabel: {
                                display: true,
                                labelString: this.ylabel
                            }
                        }]
                    }})
        }
    }
</script>